import { CONTRACT_STATUS_COLOR_MAP } from "@synota-io/synota-shared-ui";
import { IDashboardContract } from "../../../../api/hooks/useContracts";
import { Box, styled, Tooltip } from "@mui/material";

const StyledBadge = styled(Box, {
  shouldForwardProp(propName: string) {
    return !["state", "hidden"].includes(propName);
  },
})<{
  state: "success" | "warning" | "info" | "error";
  hidden: boolean;
}>(({ state, hidden, theme }) => ({
  borderRadius: "50%",
  width: "0.8em",
  height: "0.8em",
  backgroundColor: theme.palette[state].main,
  opacity: hidden ? 0.5 : 1,
}));

export const ContractStatusBadgeCell = ({ contract }: { contract: IDashboardContract }) => {
  if (!contract.contract_state) {
    return null;
  }
  return (
    <Tooltip
      arrow
      placement="left"
      title={`${contract.contract_state}${contract.hidden ? " (Hidden)" : ""}`}
    >
      <Box display="flex" height="100%" alignItems="center" pl={2}>
        <StyledBadge
          hidden={contract.hidden}
          state={CONTRACT_STATUS_COLOR_MAP[contract.contract_state]}
        />
      </Box>
    </Tooltip>
  );
};
